// @ts-nocheck
export default {
  SETTING_LIST_SET: 'SETTING_LIST_SET',
  CLEAR_OPTIONS_FORM_ERRORS: 'CLEAR_OPTIONS_FORM_ERRORS',
  SETTING_SET: 'SETTING_SET',
  SETTING_ADD: 'SETTING_ADD',
};
